// extracted by mini-css-extract-plugin
export default {"descriptionList":"DescriptionList_descriptionList__nlmHI"};